import { ClockFading, ChevronRight } from 'lucide-react';
import cn from 'classnames';
import { matchPath, useLocation } from 'react-router-dom';
import useRequestsStore from '@/stores/request-session';
import useStore from '@/stores/sider-menu';
import { PagePath } from '@/routes/paths';
import MenuIcon from '@/layouts/main-layout/components/menu-icon';
import MenuItem from '@/layouts/main-layout/components/menu-item';
import Unread from '@/layouts/main-layout/components/unread';
import List from './list';

export default function RequestsList() {
  const { collapsed, toggleCollapsed, toggleRequestListExpanded, requestListExpanded, setRequestListExpanded } =
    useStore();

  const { totalUnreadCount } = useRequestsStore();
  const location = useLocation();
  const isActive = !!matchPath(PagePath.chat, location.pathname);

  if (collapsed) {
    return (
      <MenuIcon
        onClick={() => {
          toggleCollapsed();
          setRequestListExpanded(true);
        }}
        title="Requests"
        isActive={isActive}
      >
        <ClockFading size={16} color="#737373" />
      </MenuIcon>
    );
  }

  return (
    <div className={cn('pt-2 min-h-0 flex flex-col', requestListExpanded ? '' : 'flex-none')}>
      <MenuItem className="" icon={<ClockFading size={16} color="#737373" />} onClick={toggleRequestListExpanded}>
        <div className="flex items-center justify-between gap-1 group">
          <span>Requests</span>
          <div className="flex item-center gap-1">
            {!requestListExpanded && <Unread count={totalUnreadCount} className="flex-none group-hover:hidden" />}
            <ChevronRight
              size={14}
              className={cn(
                'flex-none self-center hidden group-hover:block transition',
                requestListExpanded && 'rotate-90'
              )}
              color="#262626"
            />
          </div>
        </div>
      </MenuItem>
      <div id="request_list_scroller" className="flex-1 overflow-y-auto">
        <List />
      </div>
    </div>
  );
}
